/**
 * Logged-out Plans & Pricing — feature matrix (Free vs Pro).
 * Labels match marketing / Figma; “Expert Pool Recommendations” maps to `export_pool_recommendations` in code.
 * `detail` is shown in a hover tooltip on the plans page.
 */
export const PLANS_COMPARISON_ROWS: {
	label: string;
	detail: string;
	free: boolean;
	pro: boolean;
}[] = [
	{
		label: "1000s of Liquidity Pools",
		detail:
			"Search and filter through thousands of Uniswap liquidity pool opportunities. Narrow by token pair, fee tier, TVL, network, and more to find pools that fit your strategy.",
		free: true,
		pro: true,
	},
	{
		label: "Uniswap V3 & V4 Protocols",
		detail: "Unilytics includes liquidity pools on each of the two latest versions of Uniswap.",
		free: true,
		pro: true,
	},
	{
		label: "Ethereum + 4 Networks",
		detail:
			"Explore liquidity pools on Ethereum mainnet plus Arbitrum, Base, Optimism, and Unichain – the networks responsible for 90%+ of Uniswap's trade volume.",
		free: true,
		pro: true,
	},
	{
		label: "1-Day Performance",
		detail:
			"Sort liquidity pools based on what the average liquidity provider is earning, based on the past 24 hours of trade volume.",
		free: true,
		pro: true,
	},
	{
		label: "7-Day Performance",
		detail:
			"Sort liquidity pools based on what the average liquidity provider is earning, based on the past 7 days of trade volume. This helps you identify pools that have staying power.",
		free: false,
		pro: true,
	},
	{
		label: "30-Day Performance",
		detail:
			"Sort liquidity pools based on what the average liquidity provider is earning, based on the past 30 days of trade volume. This helps you identify pools that have strong staying power.",
		free: false,
		pro: true,
	},
	{
		label: "Range Analyzer",
		detail: "Visualize price ranges and see how small adjustments affect your estimated income.",
		free: false,
		pro: true,
	},
	{
		label: "Income Calculator",
		detail: "Estimate your daily, monthly, and yearly income on any liquidity pool opportunity.",
		free: false,
		pro: true,
	},
	{
		label: "CSV Data Downloads",
		detail:
			"Export comprehensive liquidity pool data to a spreadsheet so that you can run your own analysis.",
		free: false,
		pro: true,
	},
	{
		label: "Priority Support",
		detail:
			"If you have any questions about using Unilytics to identify opportunities and provide liquidity, our awesome support team has your back!",
		free: false,
		pro: true,
	},
	{
		label: "Expert Pool Recommendations",
		detail:
			'Our regular email newsletter is packed with liquidity pool recommendations and "pro tips" from expert liquidity providers!',
		free: false,
		pro: true,
	},
];

export const PLANS_PRICING_COPY = {
	heroTitle: "Create a Unilytics Pro Account",
	heroSubtitle: "See more APRs, analyze price ranges, estimate your income, & more!",
	trialHeadline: "Try Unilytics Pro Free for 7 Days",
	trialSub: "No commitment. Cancel any time.",
	proStrikeMonthly: 97,
	proMonthlyLine: "7-day free trial then just $97/mo. Cancel anytime.",
	proYearlyStrike: 1164,
	proYearlyPrice: 497,
	proYearlySaveCopy: "Pre-pay for the year and save $667 (57%)",
	trialCheckbox: "Yes! Activate my 7-day free trial.",
	trialDisclosure:
		"If I choose to continue beyond my trial, I understand that I'll be billed $97/mo until I choose to cancel. I can cancel any time inside my account.",
	reactivateHeadline: "Reactivate Unilytics Pro",
	reactivateSub: "Choose a plan — billing starts today. Cancel any time in your account.",
	monthlyCheckboxNoTrial: "Yes! Activate my monthly plan.",
	monthlyDisclosureNoTrial:
		"I understand that I'll be billed $97/mo until I choose to cancel. I can cancel any time inside my account.",
	yearlyCheckbox: "Yes! Activate my yearly plan.",
	yearlyDisclosure:
		"I understand that I'll be billed $497/year until I choose to cancel. I can cancel any time inside my account.",
	proMonthlyRadioLabel: "Unilytics Pro Monthly",
	proYearlyRadioLabel: "Unilytics Pro Yearly",
	planSelectLabel: "Select a Unilytics Pro Plan",
	submitCta: "Continue",
	checkoutErrorsSummaryTitle: "To continue, please:",
	checkoutDisabledContinueAriaLabel: "Show what is required to continue",
	trustFooter: "Secured with SSL.",
	/** Shown on Stripe Checkout submit step for yearly plan only (`custom_text.submit`). */
	checkoutYearlySubmitMessage: "You're saving $667 compared to paying monthly (vs. 12× $97).",
} as const;
